<button mat-flat-button (click)="manager().click.next()">
  @if (manager().icon) {
    <mat-icon>{{ manager().icon }}</mat-icon>
  }
  {{ manager().buttonLabel }}
</button>
